export const environment = {
  production: true,
  kairos: false,
  API_ENDPOINT: 'https://clover-clientesapi.azurewebsites.net',
  CLIENT_ID: 'ee2387836d724316bd4e92d3a3f1a38c'
};



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/environments/environment.ts